/**
 * Detect in-app browsers (Facebook, Instagram, TikTok, LinkedIn, etc.)
 * These browsers block Apple Pay / Google Pay, sometimes break Stripe redirects,
 * and have caused checkout abandons in our funnel.
 */
export type InAppBrowser =
  | 'facebook'
  | 'instagram'
  | 'tiktok'
  | 'linkedin'
  | 'snapchat'
  | 'twitter'
  | 'other'
  | null;

export function detectInAppBrowser(ua?: string): InAppBrowser {
  const userAgent = (ua ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '')) || '';
  if (/FBAN|FBAV|FB_IAB|FB4A/i.test(userAgent)) return 'facebook';
  if (/Instagram/i.test(userAgent)) return 'instagram';
  if (/TikTok|musical_ly|BytedanceWebview/i.test(userAgent)) return 'tiktok';
  if (/LinkedInApp/i.test(userAgent)) return 'linkedin';
  if (/Snapchat/i.test(userAgent)) return 'snapchat';
  if (/Twitter/i.test(userAgent)) return 'twitter';
  // Generic WebView (Android) — only flag if it looks like an IAB, not a regular browser
  if (/; wv\)/i.test(userAgent)) return 'other';
  return null;
}

export function isInAppBrowser(ua?: string): boolean {
  return detectInAppBrowser(ua) !== null;
}
